import { render, staticRenderFns } from "./department-list.vue?vue&type=template&id=35e8228e&scoped=true&"
import script from "./department-list.vue?vue&type=script&lang=js&"
export * from "./department-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8228e",
  null
  
)

export default component.exports